export const SET_SWITCHER = 'finto/prodSwitcher/SET_SWITCHER';
